import config from '../../config/config';

import getRequest from './base/get';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the stripe payouts list with pagination
   */
  fetchStripePayouts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.transactionApiUrl}api/super-admin/v1/revenue-payout`, {
      ...parameters,
    });
  },
  /**
   * Fetch the stripe payouts list filters
   */
  fetchStripePayoutsListFilters: (): Promise<any> => {
    return getRequest(`${config.transactionApiUrl}api/super-admin/v1/revenue-payout/list-filters`);
  },
  /**
   * Export stripe payouts data
   */
  exportStripePayouts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.transactionApiUrl}api/super-admin/v1/revenue-payout/export-data`, {
      ...parameters,
    });
  },
  /**
   * Approve stripe payouts
   * @param id
   * @returns
   */
  approveStripePayouts: (id: string): Promise<any> => {
    return postRequest(
      `${config.transactionApiUrl}api/super-admin/v1/revenue-payout/transfer/${id}`,
      {},
    );
  },
  /**
   * Reject stripe payouts
   * @param id
   * @returns
   */
  rejectStripePayouts: (id: string): Promise<any> => {
    return postRequest(
       `${config.transactionApiUrl}api/super-admin/v1/revenue-payout/reject/${id}`,
      {},
    );
  },
  /**
   * stripe payouts pending counts
   */
  fetchStripePendingCount :(query:QueryParameters = {}):Promise<any>=>{
    const parameter = {...query}
    return getRequest(
      `${config.transactionApiUrl}api/super-admin/v1/revenue-payout/pending-count`,
      {...parameter}

    )
  }
};
